import { call, takeLatest } from "redux-saga/effects";
import axiosInstance from "../axiosInstance";
import ENV from "../config/env";
import {
  HOSPITAL_LIST_REQUEST,
  GET_HOSPITAL_BASIC_INFO_REQUEST,
  GET_HOSPITAL_DEMOGRAPHIC_INFO_REQUEST,
  GET_HOSPITAL_OWNERSHIP_INFO_REQUEST,
  GET_HOSPITAL_OTHER_DETAILS_REQUEST,
  GET_HOSPITAL_HOSTEL_DETAILS_REQUEST,
  GET_HOSPITAL_SOCIAL_INFO_REQUEST,
  GET_HOSPITAL_DOCUMENT_INFO_REQUEST,
  HOSPITAL_ACTIVE_DEACTIVE_REQUEST,
  HOSPITAL_STATUS_UPDATE_REQUEST,
  HOSPITAL_SAVE_QUERY_REQUEST,
  HOSPITAL_SAVE_SUBSCRIPTION_MAPPING_REQUEST,
} from "./hospitalManagement.types";

function getErrorMessage(error) {
  return (
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error.message ||
    "Something went wrong"
  );
}

function* hospitalListSaga(action) {
  const { payload, callback } = action;
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.COMPANY_SERVICE_URL}/listing/Companies`,
      payload
    );
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* getHospitalBasicInfoSaga(action) {
  const { payload: { id }, callback } = action;
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.COMPANY_SERVICE_URL}/get/CompanyBasicInfo?id=${id}`,
      {}
    );
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* getHospitalDemographicInfoSaga(action) {
  const { payload: { id }, callback } = action;
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.COMPANY_SERVICE_URL}/get/CompanyDemographicInfo?id=${id}`,
      {}
    );
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* getHospitalOwnershipInfoSaga(action) {
  const { payload: { id }, callback } = action;
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.COMPANY_SERVICE_URL}/get/CompanyOwnershipAndLegalInfo?id=${id}`,
      {}
    );
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* getHospitalOtherDetailsSaga(action) {
  const { payload: { id }, callback } = action;
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.COMPANY_SERVICE_URL}/get/CompanyOtherDetails?id=${id}`,
      {}
    );
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* getHospitalHostelDetailsSaga(action) {
  const { payload: { id }, callback } = action;
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.COMPANY_SERVICE_URL}/get/CompanyHostelDetails?id=${id}`,
      {}
    );
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* getHospitalSocialInfoSaga(action) {
  const { payload: { id }, callback } = action;
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.COMPANY_SERVICE_URL}/get/CompanySocialInfo?id=${id}`,
      {}
    );
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* getHospitalDocumentInfoSaga(action) {
  const { payload: { id }, callback } = action;
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.COMPANY_SERVICE_URL}/get/CompanyDocInfo?id=${id}`,
      {}
    );
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* hospitalActiveDeactiveSaga(action) {
  const { payload: { endPoint }, callback } = action;
  try {
    const { data } = yield call(axiosInstance.post, endPoint, {});
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* hospitalStatusUpdateSaga(action) {
  const { payload: { endPoint }, callback } = action;
  try {
    const { data } = yield call(axiosInstance.post, endPoint, {});
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* hospitalSaveQuerySaga(action) {
  const { payload, callback } = action;
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.COMPANY_SERVICE_URL}/save/CompanyQuery`,
      payload
    );
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

function* hospitalSaveSubscriptionMappingSaga(action) {
  const { payload, callback } = action;
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${ENV.COMPANY_SERVICE_URL}/save/CompanySubscriptionMapping`,
      payload
    );
    if (callback) yield call(callback, { success: true, data });
  } catch (error) {
    const msg = getErrorMessage(error);
    if (callback) yield call(callback, { success: false, error: msg });
  }
}

export function* hospitalManagementWatcherSaga() {
  yield takeLatest(HOSPITAL_LIST_REQUEST, hospitalListSaga);
  yield takeLatest(GET_HOSPITAL_BASIC_INFO_REQUEST, getHospitalBasicInfoSaga);
  yield takeLatest(GET_HOSPITAL_DEMOGRAPHIC_INFO_REQUEST, getHospitalDemographicInfoSaga);
  yield takeLatest(GET_HOSPITAL_OWNERSHIP_INFO_REQUEST, getHospitalOwnershipInfoSaga);
  yield takeLatest(GET_HOSPITAL_OTHER_DETAILS_REQUEST, getHospitalOtherDetailsSaga);
  yield takeLatest(GET_HOSPITAL_HOSTEL_DETAILS_REQUEST, getHospitalHostelDetailsSaga);
  yield takeLatest(GET_HOSPITAL_SOCIAL_INFO_REQUEST, getHospitalSocialInfoSaga);
  yield takeLatest(GET_HOSPITAL_DOCUMENT_INFO_REQUEST, getHospitalDocumentInfoSaga);
  yield takeLatest(HOSPITAL_ACTIVE_DEACTIVE_REQUEST, hospitalActiveDeactiveSaga);
  yield takeLatest(HOSPITAL_STATUS_UPDATE_REQUEST, hospitalStatusUpdateSaga);
  yield takeLatest(HOSPITAL_SAVE_QUERY_REQUEST, hospitalSaveQuerySaga);
  yield takeLatest(HOSPITAL_SAVE_SUBSCRIPTION_MAPPING_REQUEST, hospitalSaveSubscriptionMappingSaga);
}
